import {createUseStyles} from 'react-jss';
import Spacing from '../../../style-helper/Spacing';

export default createUseStyles({
  currentLocation: {
    display: 'flex',
    
    '& #currentLocation': {
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      color: '#333',
      textTransform: 'none',
    },
    
    '& .Button__icon': {
      marginRight: Spacing.double,
    },
  },
});
